import { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Visibility from "@material-ui/icons/Visibility";
import { useAttendanceLocalMapStyles } from "./styles";
import { Totem } from "../../../../../../../@types/totem";
import { toast } from "react-toastify";
import { useTotemStyles } from "../../../../../styles";

type Props = {
    totem: Totem
};

export default function TotemResetPassword({ totem }: Props) {
    const [open, setOpen] = useState(false);
    const { classes: defaultClasses } = useTotemStyles();
    const { classes } = useAttendanceLocalMapStyles();

    function handleCopyToClipboard() {
        navigator.clipboard.writeText(totem.senha_reset)
            .then(() => {
                toast.success("Senha de reset copiada para a área de transferência!");
            })
            .catch(() => {
                toast.error("Erro ao copiar a senha de reset para a área de transferência.");
            });
    }

    return (
        <>
            <Button
                startIcon={<Visibility fontSize="small" />}
                className={classes.button}
                onClick={() => setOpen(true)}
            >
                Visualizar Senha
            </Button>
            <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md">
                <Card>
                    <CardHeader
                        avatar={<Visibility />}
                        title={<Typography variant="h5">Senha de Reset</Typography>}
                        className={classes.cardHeader}
                    />
                    <CardContent className={classes.cardContent}>
                        <TextField
                            fullWidth
                            label="Senha de Reset"
                            value={totem?.senha_reset || ""}
                            variant="outlined"
                            inputProps={{
                                readOnly: true,
                            }}
                        />
                    </CardContent>
                    <CardActions className={classes.cardActions}>
                        <Button
                            className={classes.button}
                            onClick={() => setOpen(false)}
                        >
                            Fechar
                        </Button>
                        <Button
                            className={defaultClasses.addButton}
                            onClick={handleCopyToClipboard}
                        >
                            Copiar
                        </Button>
                    </CardActions>
                </Card>
            </Dialog>
        </>
    );
}
